var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.tag-dot-svg{fill:currentColor;}\n\t.tag-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tag-dot-svg",
    d: "M11,6c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S10.4,6,11,6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "tag-svg",
    d: "M8,0.8h7.2V8l-6.7,6.7c-0.8,0.8-2.1,0.8-2.9,0L1.3,9.9C0.5,9.1,0.6,7.9,1.4,7.1L8,0.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.9fc89d946da4405ba21972156ec6054c.svg";
export { ForwardRef as ReactComponent };